import { includes, toLower } from 'lodash';

/** 
 * This function to support filter the feature items associate to generic object 
 * Example: filterItems(items, {type: ['story', 'clip'], displaysize: ['-20', '-7']});
 * @param {Object} items - The items are assigned to category feed.
 * @param {Object} filterObject - The object is used to make filter conditions.
 * @return {Object} The items are associate to filter conditions.
*/
const filterItems = (items, filterObject) => {
    let filteredItems = items;
    for (const key in filterObject) {
        if (filterObject[key].length > 0) {
            filteredItems = filteredItems.filter(item => includes(filterObject[key], toLower(item[key])));
        }
    }
    return filteredItems;
};

export { filterItems };



// WEBPACK FOOTER //
// ./app/utils/CategoryUtils.js